/*
  This is a utility class that combines classnames
  and tailwind-merge to allow for the merging of classes
  and remove duplication of tailwind classnames
*/

import classnames from "classnames";
import { twMerge } from "tailwind-merge";

export default function cn(...args) {
  return twMerge(classnames(args));
}
